export default [
	{
		path: '/orders',
		name: 'Orders',
		meta: {
			requiresAuth: true,
			section: 'orders',
		},
		component: () => import('@/views/orders/Orders'),
	},
	{
		path: '/orders/:id',
		name: 'OrderDetail',
		meta: {
			requiresAuth: true,
			section: 'orders',
		},
		component: () => import('@/views/orders/OrderDetail'),
	},
]
